import i18n from 'modules/core/lib/i18n'

export const validateTitle = (title: string) => {
  if (title.length === 0) {
    return i18n.t('performance_cycles.new_cycle_modal.validation_errors.title')
  }
}

export const validateDate = (startOn: string, endOn: string) => {
  if (endOn <= startOn) {
    return i18n.t('performance_cycles.new_cycle_modal.validation_errors.date')
  }
}
